import React, { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';
import { cdnUrlConfig } from '../../../Utils/atoms';

const PrizePopUp = (props) => {
	const cdnUrl = useRecoilValue(cdnUrlConfig);
	const IMG_URL = `${cdnUrl}`;
	const rewardResult = props.rewardResult;
	const eventName = props.eventName;
	const eventCategory = props.eventCategoryType;
	const [rewardImageUrl, setRewardImageUrl] = useState();

	const handleConfirmClick = () => {
		props.close();
	};

	useEffect(() => {
		if (rewardResult.rank_no < 5) {
			setRewardImageUrl(rewardResult.reward_thumbnail_lk);
		}
		if (rewardResult.rank_no == 6 || rewardResult.rank_no == 8) {
			setRewardImageUrl('/BigglzEvent/images/draw-lots/img_reward1.png');
		}
		if (rewardResult.rank_no == 5 || rewardResult.rank_no == 7) {
			setRewardImageUrl('/BigglzEvent/images/draw-lots/img_reward2.png');
		}
	}, []);

	useEffect(() => {
		window.MixPanelCompleteEvent(
			eventName,
			eventCategory,
			rewardResult.event_reward_info_nm
		);
	}, [rewardResult]);

	return (
		<>
			<div className='dim'></div>
			<div className='popup pop-prize'>
				<header>
					<h2>
						<img
							src={`${IMG_URL}/BigglzEvent/images/draw-lots/pop_tit.png`}
							alt='당첨을 축하합니다'
						/>
					</h2>
				</header>
				<div className='content'>
					<div className='product'>
						<div className='photo'>
							<img src={`${IMG_URL + rewardImageUrl}`} alt='' />
						</div>
						<div className='name'>
							{rewardResult.event_reward_info_nm} {rewardResult.reward_cn}개
						</div>
					</div>
				</div>
				<div className='btn-area'>
					<button onClick={handleConfirmClick}>확인</button>
				</div>
			</div>
		</>
	);
};

export default PrizePopUp;
